
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Image } from 'element-ui'
Vue.use(Image)
@Component({
  components: {}
})
export default class PosterImage extends Vue {
  @Prop() private url!: string

  get getBgImg () {
    if (!this.url) {
      return {}
    }
    return {
      'background-image': `url(${this.url})`
    }
  }
}
